var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRf1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_663",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_663",
    transform: "scale(0.0208333 0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_663",
    width: 48,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAtCAQAAABCQyBJAAAD+UlEQVRYw62XbWwUVRSGF3ju7LBAA4JUKAJChIQU0tAYwg8jH6INiRZS+IFICYiCfEXUQKgGLD8ICeoGFa2a9AdqbaMIoY0BNZEQLBij1iYSjR9IBLUEqAgF2lqHd2enH+4u3e7O3PtjZu7Ovu85557znjuhkM8xoz9lnOICn1EYCn4I/kNuEGUjx/iXRwMn4AXamWtHTJ7Tj9foCJiCIkE+a+6iCYdXAqewxnGR/aJZRyubFKA3RbE3MArCfMWP5OhuElf4mOWiqAiQggpayPfu702gaGOaX/hSRb2HnT0oosqskxz0Bz+Fa+xNWItTPI9jDWYbP/sjOESjZSWtxigcTilI7/O5D3gBXGVdql/MeJZYt7GC/yj158HfbEr9i214VV7s9rvF73HGDE+xPoYTXGeF/xTdISsbEim4n/P8Ygr8w28UfJRzPSm0L8+pwA7ZQ33DRwbKzmq3fmMUI2Jr4WHUqQK2Ov2CgP+UyzHll83V8uSscr5cVE3MCUaBKgU/U9f5HJVQr+ZtzmhWWHcEAz9VcV6pa4nAv2dBKMghhSnnHxrtoQpKO5Uz+oeCHayRRu6QD39IRcuDhy/kB7e5VHI2w3ibESzjMW+WWqNSwkeVL42sol7XVZna1qCNa/dmB78mvzHEVo5vtyNKxnoeztx5h+Vd9wv0lJPkY4FWn+Et2qxx2UTX6ZZWivX0Dm+wk5VM7VqdrlWHZp7KbvsSCY7ztcBikN/xRHiQuz7F5GWfH4kEOZ66zKZKidnM7szB1TRjiTOyFwLvOZftkrZWHQ/XmwJrcB9NXqz/OEqZZqanIfDk7UkdbK+6QbuksNXyOltZaibcIulr9N67Jk/GfcsnfSCID7XCQhbp/PayvPmSP9V1HZ0hbk+wvUSq+hfF3tOLbtL3RmAms0V/yh9iJ4UhzEP8zhfdkmGGu/Jd1dmEuFtU+9LtQbFsjYWmg9McZg9rmcudnW1FPjkUefcLBdfEwh6+XKbRbUfpQkQO97BUMlejmm9x6VoU3Wpp6yOCjEYGyvYqrVbHu5sqH17S8z47kjaLEoe62FjmsV5HkyP85u5DfJ6npCtUo1VJN1idpg76MpRf03hAW7+s03YhzJFXp//3MZU9QQr/yiSLdeFhvVfy2OzgVfu1gi9LOlkkEbTyAfNzB2QoOLMUmNQniySCzfpycaT9u8zkPgRljDRrg7bc4YgZnZr7ogBrvFnPddtoLV+JFvuwq+fxxD1RltwnIdvFfvW4a17a1rLo1s4V8ZHOZfF5oLtUlM3FHJRktahDrFG73KnQNXia1Kavszo10rXMM+N9HQAYydN8I8B2fpL27FENPMjETHco7cgdEPgxJbhxE5MPbT9wHUPSAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf1);
export default __webpack_public_path__ + "static/media/rf1.5af65e71923d5b298c6d412d6c4ef24a.svg";
export { ForwardRef as ReactComponent };